import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { LogLevel } from "abweb/utils/log/LogLevel";
import { LogRecord } from "abweb/utils/log/LogRecord";
export class InMemoryLogger {
  // Restore the line limit back to 20000 because now the size of the file is limited
  // directly in bytes (100000). See changes in LogUtils.getLoggerText function.
  constructor(maxLength = 20000) {
    _defineProperty(this, "_messages", []);
    _defineProperty(this, "maxLength", void 0);
    this.maxLength = maxLength;
  }
  debug(logger, message) {
    this.log(LogLevel.debug, logger, message);
  }
  info(logger, message) {
    this.log(LogLevel.info, logger, message);
  }
  warn(logger, message) {
    this.log(LogLevel.warn, logger, message);
  }
  error(logger, message) {
    this.log(LogLevel.error, logger, message);
  }
  log(level, logger, message) {
    if (level > logger.level) {
      return;
    }
    const id = logger.id;
    // If level of message is 'error', construct an Error to generate a stack in the LogRecord.
    const logRecord = new LogRecord(level, id, message, level === LogLevel.error ? Error("") : null);
    this._messages.push(logRecord);

    // asynchronously clean the stack in the Error
    if (level === LogLevel.error) {
      logRecord.cleanStack().then(/* deliberately ignore resolve */);
    }
    if (this._messages.length > this.maxLength) {
      this._messages.shift();
    }
  }
  get messages() {
    return this._messages;
  }
}
//# sourceMappingURL=InMemoryLogger.js.map
